import { ReportHandler } from 'web-vitals'
import * as amplitude from '@amplitude/analytics-browser'
import * as Sentry from '@sentry/react'

function sendToAnalytics(metric: any) {
  // Send to Amplitude
  try {
    amplitude.track('Web Vital', {
      name: metric.name,
      value: Math.round(metric.value),
      id: metric.id,
      delta: Math.round(metric.delta),
      rating: metric.rating,
    })
  } catch (error) {
    console.warn('Failed to send Web Vital to Amplitude:', error)
  }

  // Send to Sentry for performance monitoring
  try {
    // Use Sentry's breadcrumb or custom event for metrics
    // Note: Sentry.metrics API may not be available in all versions
    if (Sentry.metrics && typeof Sentry.metrics.distribution === 'function') {
      Sentry.metrics.distribution(metric.name, metric.value, {
        tags: { rating: metric.rating },
        unit: metric.name === 'CLS' ? undefined : 'millisecond',
      })
    } else {
      // Fallback: use breadcrumb for tracking
      Sentry.addBreadcrumb({
        category: 'web-vital',
        message: `${metric.name}: ${Math.round(metric.value)}`,
        level: metric.rating === 'good' ? 'info' : metric.rating === 'needs-improvement' ? 'warning' : 'error',
        data: {
          value: Math.round(metric.value),
          rating: metric.rating,
          delta: Math.round(metric.delta),
        },
      })
    }
  } catch (error) {
    console.warn('Failed to send Web Vital to Sentry:', error)
  }

  // Log to console in development
  if (process.env.NODE_ENV === 'development') {
    console.log(`[Web Vital] ${metric.name}:`, {
      value: Math.round(metric.value),
      rating: metric.rating,
      delta: Math.round(metric.delta),
    })
  }
}

const reportWebVitals = (onPerfEntry?: ReportHandler) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(sendToAnalytics)
      getFID(sendToAnalytics)
      getFCP(sendToAnalytics)
      getLCP(sendToAnalytics)
      getTTFB(sendToAnalytics)
      
      // Also call original handler if provided
      getCLS(onPerfEntry)
      getFID(onPerfEntry)
      getFCP(onPerfEntry)
      getLCP(onPerfEntry)
      getTTFB(onPerfEntry)
    })
  } else {
    // Even if no handler provided, still track metrics
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(sendToAnalytics)
      getFID(sendToAnalytics)
      getFCP(sendToAnalytics)
      getLCP(sendToAnalytics)
      getTTFB(sendToAnalytics)
    })
  }
}

export default reportWebVitals
